module.exports = __webpack_public_path__ + "img/alarm-screen.97141c59.svg";